import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, Home } from "lucide-react";
import { useUiPack } from "@/hooks/useUiPack";
import { useLocale } from "@/contexts/LocaleProvider";
import ReportCenterLayout from "@/components/reports/ReportCenterLayout";
import SimpleReportsHub from "@/pages/simple/SimpleReportsHub";
import { ReportBranchProvider } from "@/contexts/ReportBranchContext";
import "@/styles/simple-ui.css";

export default function UiPackReportLayout() {
  const { isSimple } = useUiPack();
  if (!isSimple) return <ReportCenterLayout />;
  return <SimpleReportLayout />;
}

function SimpleReportLayout() {
  const { t } = useTranslation();
  const { isRtl } = useLocale();
  const { pathname } = useLocation();
  const isHome = pathname === "/reports" || pathname === "/reports/";

  return (
    <ReportBranchProvider>
      <div className="simple-ui flex h-full min-h-0 flex-col" dir={isRtl ? "rtl" : "ltr"} data-testid="simple-report-layout">
        {!isHome ? (
          <div className="flex shrink-0 flex-wrap items-center gap-2 border-b border-violet-200 bg-violet-600 px-3 py-2 text-white print:hidden">
            <Link to="/" className="inline-flex h-10 items-center gap-1.5 rounded-xl bg-white/15 px-3 text-sm font-bold hover:bg-white/25">
              <Home className="h-4 w-4" />
              {t("common.home")}
            </Link>
            <Link to="/reports" className="inline-flex h-10 items-center gap-1.5 rounded-xl bg-white/15 px-3 text-sm font-bold hover:bg-white/25">
              <ArrowLeft className="h-4 w-4" />
              {t("nav.reports")}
            </Link>
          </div>
        ) : null}
        <div className="min-h-0 flex-1 overflow-auto bg-[#EEF0F7]">
          {isHome ? <SimpleReportsHub /> : (
            <div className="p-3 sm:p-4">
              <Outlet />
            </div>
          )}
        </div>
      </div>
    </ReportBranchProvider>
  );
}
